<template>
  <div id="CategoryChildren" class="container ml-1">
    <div class="row no-gutters ml-1">
      <div v-for="category in children" :key="category.Title" class="col col-12">
        <div class="row no-gutters category-children-nonleaf-header">
          <h2>{{ category.Title }}</h2>
          <loading-spinner
            v-if="GetChildrenLoading(category.Id)?.childrenAreLoading && disableLoadingSpinner === false"
          />
        </div>
        <b-row v-if="category.IsLeaf === true">
          <b-col  cols="6" sm="4" md="3">
          <catalog-card :title="category.Title" :category-image-id="category.Image" :category-id="category.Id" />
          </b-col>
        </b-row>
        <b-row v-else-if="GetChildrenLoading(category.Id)?.childrenAreLoading === false">
          <b-col v-for="childCategory in category.ChildCategories" :key="childCategory.Title" cols="6" sm="4" md="3">
            <catalog-card
              :title="childCategory.Title"
              :category-image-id="childCategory.Image"
              :category-id="childCategory.Id"
              :is-leaf="childCategory.IsLeaf"
            />
          </b-col>
        </b-row>
        <hr v-if="category.Title !== children[children.length - 1].Title" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CatalogService } from "@/services/CatalogService";
import LoadingSpinner from "@/components/Elements/LoadingSpinner";
import CatalogCard from "@/components/Elements/CatalogCard";

import { brandAndRegionAuthHelper } from "@/components/mixins";
export default {
  components: {
    LoadingSpinner,
    CatalogCard,
  },
  mixins: [brandAndRegionAuthHelper],
  props: {
    parentCategoryId: {
      default: 0,
    },
    staticChildren: {
      type: Array,
    },
    disableLoadingSpinner: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    children: {
      type: Array,
    },
    // status of the loading of children, by categoryId
    loadingChildren: [
      {
        categoryId: 0,
        childrenAreLoading: false,
      },
    ],
  }),
  computed: {
    ...mapGetters(["user", "activeAccountId", "brandAuth", "regionAuth", "audienceIds"]),
    LeafChildren() {
      return this.children.filter((c) => c.IsLeaf === true);
    },
    NonLeafChildren() {
      return this.children.filter((c) => c.IsLeaf === false);
    },
  },
  created() {
    this.children = this.staticChildren.filter((x) => this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth));

    this.children
      .filter((c) => !c.IsLeaf)
      .forEach((child) => {
        this.loadingChildren.push({
          categoryId: child.Id,
          childrenAreLoading: true,
        });
      });

    var childIds = this.children.map((c) => c.Id);
    var costCenterRootCategoryId = this.$store.state.tenant.costCenterRootCategoryId;
    CatalogService.GetChildCategories(
      this.activeAccountId,
      this.user.UserId,
      costCenterRootCategoryId,
      this.brandAuth,
      this.regionAuth,
      this.audienceIds,
      childIds
    ).then((grandChildren) => {
      this.children
        .filter((c) => !c.IsLeaf)
        .forEach((child) => {
          let childIndex = this.children.indexOf(child);
          let self = this;
          var grandChildrenGroup = grandChildren.data.filter((x) => x.ParentCategoryId === child.Id);
          self.children[childIndex].ChildCategories = grandChildrenGroup.filter((x) =>
            this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth)
          );

          let childrenLoading = self.GetChildrenLoading(child.Id);
          childrenLoading.childrenAreLoading = false;
          this.$emit("loaded");
        });
    });
  },
  methods: {
    MediaUrl(imageId) {
      return CatalogService.GetMediaUrl(imageId);
    },
    GetChildrenLoading(categoryId) {
      return this.loadingChildren.filter((child) => {
        return child.categoryId === categoryId;
      })[0];
    },
  },
};
</script>

<style lang="scss">
#CategoryChildren {
  padding-left: 0;
}
.category-children-nonleaf-header {
  .element-loading {
    display: inline-block;
    padding: 19px;
  }
}
.category-children-nonleaf-row {
  width: 100%;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
</style>